import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        component: 'wtDocumentationState',
        name: 'documentation',
        url: '/documentation',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer, Roles.operator, Roles.reader])
        },
        abstract: false,
        redirectTo: 'documentation.application',
        data: {
            visible: true,
            isMobileVisible: true,
            sortingOrder: 21,
            icon: 'fa-file-text',
            displayName: 'Application documentation',
            editButtonVisibility: () => false,
        }
    }, {
        template: '<wt-documentation-application-state class="flex-directive col" has-edit-role="vm.hasEditRole"></wt-documentation-application-state>',
        name: 'documentation.application',
        url: '/application',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer, Roles.operator, Roles.reader])
        },
        abstract: false,
        data: {
            visible: false,
            sortingOrder: 100,
            icon: 'fa-cogs',
            displayName: 'Application',
            editButtonVisibility: () => false,
        }
    }, {
        template: '<wt-auto-generated class="flex-directive col" has-edit-role="vm.hasEditRole"></wt-auto-generated>',
        name: 'documentation.autoGenerated',
        url: '/autogenerated',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer, Roles.operator, Roles.reader])
        },
        abstract: false,
        data: {
            visible: false,
            sortingOrder: 200,
            icon: 'fa-file-text',
            displayName: 'Auto-generated application documentation',
            editButtonVisibility: () => false,
            isExperimental: true
        }
    }
];

export default states;